import ResponsivePageNavigation from './ResponsivePageNavigation';
import React from 'react';
import {useTodayLayout} from './TodayLayoutContext';
import {useInRouterContext,useNavigate} from 'react-router-dom';
import {useCurrentVesselNavigation} from './VesselNavigation';
import {todayGoalsAvailable} from '@/lib/todayGoalsAccess';
import {myGuestsAvailable} from '@/lib/myGuestsAccess';

/** Persistent Today destinations, independent of the page's local controls. */
export default function TodayNavigation({user, current, navigate, owner=false}) {
  const inRouter=useInRouterContext();
  const layout=useTodayLayout();
  if(layout&&!owner)return null;
  if(navigate)return <NavigationLinks user={user} current={current} follow={navigate}/>;
  return inRouter?<RoutedNavigation user={user} current={current}/>:<NavigationLinks user={user} current={current}/>;
}

function RoutedNavigation({user,current}) {
  const navigate=useNavigate();
  const navigationConfig=useCurrentVesselNavigation();
  const follow=to=>{
    const action=()=>navigate(to);
    if(navigationConfig?.beforeLeave?.(action)!==false)action();
  };
  return <NavigationLinks user={user} current={current} follow={follow}/>;
}

function NavigationLinks({user,current,follow}) {
  const layout=useTodayLayout();
  const items = [
    ...(user?.role==='front_desk' ? [] : [{id:'day', label:'Today', href:'/home'}]),
    {id:'personal', label:'My Day', href:'/my-day'},
    {id:'team', label:'Today’s Team', href:'/today/team?view=team'},
    ...(myGuestsAvailable(user) ? [{id:'guests', label:'Today’s Guests', href:'/my-day?view=guests'}] : []),
    ...(todayGoalsAvailable(user) ? [{id:'goals',label:'Today’s Goals',href:'/today/goals'}] : []),
    {id:'eg', label:'Daily Communications Log', href:'/today/team?view=eg'},
    {id:'mt', label:'Room Assignments', href:'/today/team?view=mt'},
    {id:'eod', label:'End of Day', href:'/operations/eod'},
  ];
  const roomActions=!layout && current==='mt' ? <div className="mt-room-navigation-actions" data-mt-unassigned-controls/> : null;
  const pages=items.map(item=>({id:item.id,label:item.label,to:item.href,glyph:({day:'today',goals:'today',personal:'profile',team:'team',guests:'profile',eg:'team',mt:'scheduling',eod:'calendar'})[item.id],onSelect:follow?()=>{if(current!==item.id)follow(item.href);}:undefined}));
  return <ResponsivePageNavigation label="Your day" current={current} items={pages} secondary={roomActions}><nav className="today-dashboard__tabs sonmi-nav sonmi-nav--primary today-navigation" aria-label="Your day" data-vessel-page-navigation>
    {items.map(item=><a key={item.id} href={item.href} aria-current={current===item.id?'page':undefined} onClick={event=>{
      if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      if(current===item.id){event.preventDefault();return;}
      if(follow){event.preventDefault();follow(item.href);}
    }}><span className="vessel-slider__label">{item.label}</span></a>)}
    {!layout && current==='mt' && <div className="mt-room-navigation-actions" data-mt-unassigned-controls/>}
  </nav></ResponsivePageNavigation>;
}
